import { connect } from 'react-redux';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { MultiSelectFilterOptions } from '../components/filters/MultiSelectFilterOptions';
import { searchFilterActions } from './filters.helpers';

const { toggleItemIdWithoutUpdate } = searchFilterActions;

const mapStateToProps = (state, ownProps) => {
  const { filterName } = ownProps;

  const filters = filterSetFilters(state, SEARCH);
  const filterData = deepExtract(`${filterName}`, filters, {});
  const items = filterData.itemsById || {};
  const parentedItemIds = filterData.parentedItemIds || {};
  const selectedItems = filterData.itemIdSelected || {};

  return {
    items,
    parentedItemIds,
    selectedItems,
  };
};

const mapDispatchToProps = {
  onToggle: toggleItemIdWithoutUpdate,
};

export const MultiSelectFilterOptionsContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('MultiSelectFilterOptionsContainer')
)(MultiSelectFilterOptions);
